import { LitElement, css, html, svg } from 'lit'


const orangeGradient = svg`
<defs>
    <linearGradient id="paint0_linear_153_57" x1="29.7" y1="25.1625" x2="2.475" y2="8.6625" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FE9500"/>
        <stop offset="1" stop-color="#F95500"/>
    </linearGradient>
</defs>
`
const homeButton = svg`
<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16.5" cy="16.5" r="16.5" fill="url(#paint0_linear_153_57)"/>
        <path d="M9.5 23.9999C9.08333 23.9999 8.72917 23.8541 8.4375 23.5624C8.14583 23.2707 8 22.9166 8 22.4999V20.5999L12 17.0499V23.9999H9.5ZM13 23.9999V19.9999H21V23.9999H13ZM22 23.9999V15.7999L17.725 11.9999L20.75 9.3249L25.5 13.5499C25.6667 13.6999 25.7917 13.8707 25.875 14.0624C25.9583 14.2541 26 14.4582 26 14.6749V22.4999C26 22.9166 25.8542 23.2707 25.5625 23.5624C25.2708 23.8541 24.9167 23.9999 24.5 23.9999H22ZM8 19.2499V14.6749C8 14.4582 8.04167 14.2499 8.125 14.0499C8.20833 13.8499 8.33333 13.6832 8.5 13.5499L16 6.8999C16.1333 6.76657 16.2875 6.67074 16.4625 6.6124C16.6375 6.55407 16.8167 6.5249 17 6.5249C17.1833 6.5249 17.3625 6.55407 17.5375 6.6124C17.7125 6.67074 17.8667 6.76657 18 6.8999L20 8.6749L8 19.2499Z" fill="white"/>
    ${ orangeGradient }
</svg>`

const catalogButton = svg`
<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16.5" cy="16.5" r="16.5" fill="url(#paint0_linear_153_57)"/>
    <path d="M11 25C10.45 25 9.97917 24.8042 9.5875 24.4125C9.19583 24.0208 9 23.55 9 23C9 22.45 9.19583 21.9792 9.5875 21.5875C9.97917 21.1958 10.45 21 11 21C11.55 21 12.0208 21.1958 12.4125 21.5875C12.8042 21.9792 13 22.45 13 23C13 23.55 12.8042 24.0208 12.4125 24.4125C12.0208 24.8042 11.55 25 11 25ZM17 25C16.45 25 15.9792 24.8042 15.5875 24.4125C15.1958 24.0208 15 23.55 15 23C15 22.45 15.1958 21.9792 15.5875 21.5875C15.9792 21.1958 16.45 21 17 21C17.55 21 18.0208 21.1958 18.4125 21.5875C18.8042 21.9792 19 22.45 19 23C19 23.55 18.8042 24.0208 18.4125 24.4125C18.0208 24.8042 17.55 25 17 25ZM23 25C22.45 25 21.9792 24.8042 21.5875 24.4125C21.1958 24.0208 21 23.55 21 23C21 22.45 21.1958 21.9792 21.5875 21.5875C21.9792 21.1958 22.45 21 23 21C23.55 21 24.0208 21.1958 24.4125 21.5875C24.8042 21.9792 25 22.45 25 23C25 23.55 24.8042 24.0208 24.4125 24.4125C24.0208 24.8042 23.55 25 23 25ZM11 19C10.45 19 9.97917 18.8042 9.5875 18.4125C9.19583 18.0208 9 17.55 9 17C9 16.45 9.19583 15.9792 9.5875 15.5875C9.97917 15.1958 10.45 15 11 15C11.55 15 12.0208 15.1958 12.4125 15.5875C12.8042 15.9792 13 16.45 13 17C13 17.55 12.8042 18.0208 12.4125 18.4125C12.0208 18.8042 11.55 19 11 19ZM17 19C16.45 19 15.9792 18.8042 15.5875 18.4125C15.1958 18.0208 15 17.55 15 17C15 16.45 15.1958 15.9792 15.5875 15.5875C15.9792 15.1958 16.45 15 17 15C17.55 15 18.0208 15.1958 18.4125 15.5875C18.8042 15.9792 19 16.45 19 17C19 17.55 18.8042 18.0208 18.4125 18.4125C18.0208 18.8042 17.55 19 17 19ZM23 19C22.45 19 21.9792 18.8042 21.5875 18.4125C21.1958 18.0208 21 17.55 21 17C21 16.45 21.1958 15.9792 21.5875 15.5875C21.9792 15.1958 22.45 15 23 15C23.55 15 24.0208 15.1958 24.4125 15.5875C24.8042 15.9792 25 16.45 25 17C25 17.55 24.8042 18.0208 24.4125 18.4125C24.0208 18.8042 23.55 19 23 19ZM11 13C10.45 13 9.97917 12.8042 9.5875 12.4125C9.19583 12.0208 9 11.55 9 11C9 10.45 9.19583 9.97917 9.5875 9.5875C9.97917 9.19583 10.45 9 11 9C11.55 9 12.0208 9.19583 12.4125 9.5875C12.8042 9.97917 13 10.45 13 11C13 11.55 12.8042 12.0208 12.4125 12.4125C12.0208 12.8042 11.55 13 11 13ZM17 13C16.45 13 15.9792 12.8042 15.5875 12.4125C15.1958 12.0208 15 11.55 15 11C15 10.45 15.1958 9.97917 15.5875 9.5875C15.9792 9.19583 16.45 9 17 9C17.55 9 18.0208 9.19583 18.4125 9.5875C18.8042 9.97917 19 10.45 19 11C19 11.55 18.8042 12.0208 18.4125 12.4125C18.0208 12.8042 17.55 13 17 13ZM23 13C22.45 13 21.9792 12.8042 21.5875 12.4125C21.1958 12.0208 21 11.55 21 11C21 10.45 21.1958 9.97917 21.5875 9.5875C21.9792 9.19583 22.45 9 23 9C23.55 9 24.0208 9.19583 24.4125 9.5875C24.8042 9.97917 25 10.45 25 11C25 11.55 24.8042 12.0208 24.4125 12.4125C24.0208 12.8042 23.55 13 23 13Z" fill="white"/>
    ${ orangeGradient }
</svg>`

const cartButton = svg`
<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16.5" cy="16.5" r="16.5" fill="url(#paint0_linear_153_57)"/>
    <path d="M12.834 25.3332C12.3757 25.3332 11.9833 25.17 11.6569 24.8436C11.3305 24.5172 11.1673 24.1248 11.1673 23.6665C11.1673 23.2082 11.3305 22.8158 11.6569 22.4894C11.9833 22.163 12.3757 21.9998 12.834 21.9998C13.2923 21.9998 13.6847 22.163 14.0111 22.4894C14.3375 22.8158 14.5007 23.2082 14.5007 23.6665C14.5007 24.1248 14.3375 24.5172 14.0111 24.8436C13.6847 25.17 13.2923 25.3332 12.834 25.3332ZM21.1673 25.3332C20.709 25.3332 20.3166 25.17 19.9902 24.8436C19.6638 24.5172 19.5007 24.1248 19.5007 23.6665C19.5007 23.2082 19.6638 22.8158 19.9902 22.4894C20.3166 22.163 20.709 21.9998 21.1673 21.9998C21.6257 21.9998 22.018 22.163 22.3444 22.4894C22.6708 22.8158 22.834 23.2082 22.834 23.6665C22.834 24.1248 22.6708 24.5172 22.3444 24.8436C22.018 25.17 21.6257 25.3332 21.1673 25.3332ZM11.334 10.3332H23.6257C23.9451 10.3332 24.1882 10.4755 24.3548 10.7603C24.5215 11.045 24.5284 11.3332 24.3757 11.6248L21.4173 16.9582C21.2645 17.2359 21.0597 17.4512 20.8027 17.604C20.5458 17.7568 20.2645 17.8332 19.959 17.8332H13.7507L12.834 19.4998H22.834V21.1665H12.834C12.209 21.1665 11.7368 20.8922 11.4173 20.3436C11.0979 19.795 11.084 19.2498 11.3757 18.7082L12.5007 16.6665L9.50065 10.3332H7.83398V8.6665H10.5423L11.334 10.3332Z" fill="white"/>
    ${ orangeGradient }
</svg>`

const ordersButton = svg`
<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16.5" cy="16.5" r="16.5" fill="url(#paint0_linear_153_57)"/>
    <path d="M9 24V22H19V24H9ZM9 20V18H25V20H9ZM9 16V14H25V16H9ZM9 12V10H25V12H9Z" fill="white"/>
    ${ orangeGradient }
</svg>`

const profileButton = svg`
<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16.5" cy="16.5" r="16.5" fill="url(#paint0_linear_153_57)"/>
    <path d="M17 16C15.9 16 14.9583 15.6083 14.175 14.825C13.3917 14.0417 13 13.1 13 12C13 10.9 13.3917 9.95833 14.175 9.175C14.9583 8.39167 15.9 8 17 8C18.1 8 19.0417 8.39167 19.825 9.175C20.6083 9.95833 21 10.9 21 12C21 13.1 20.6083 14.0417 19.825 14.825C19.0417 15.6083 18.1 16 17 16ZM9 24V21.2C9 20.6333 9.14583 20.1125 9.4375 19.6375C9.72917 19.1625 10.1167 18.8 10.6 18.55C11.6333 18.0333 12.6833 17.6458 13.75 17.3875C14.8167 17.1292 15.9 17 17 17C18.1 17 19.1833 17.1292 20.25 17.3875C21.3167 17.6458 22.3667 18.0333 23.4 18.55C23.8833 18.8 24.2708 19.1625 24.5625 19.6375C24.8542 20.1125 25 20.6333 25 21.2V24H9Z" fill="white"/>
    ${ orangeGradient }
</svg>`

const closeButton = svg`
<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16.5" cy="16.5" r="16.5" fill="#E7E7E7"/>
    <path d="M12.1497 22.5417L10.458 20.85L14.808 16.5L10.458 12.1802L12.1497 10.4885L16.4997 14.8385L20.8195 10.4885L22.5111 12.1802L18.1611 16.5L22.5111 20.85L20.8195 22.5417L16.4997 18.1917L12.1497 22.5417Z" fill="#1C1B1F"/>
</svg>
`



export class MainToolbar extends LitElement {

    connectedCallback() {
        super.connectedCallback()
        document.addEventListener("DOMContentLoaded", () => {
            this.menu = document.querySelector("mobile-menu")
        })
    }

    render() {
        return html`
            <button @click=${() => window.location.href = "/"}>
                ${homeButton}
                <span>Главная</span>
            </button>
            <button @click=${ this.toogleMobileMenu }>
                ${this.menu && this.menu.classList.contains("visible") ? closeButton : catalogButton}
                <span>Каталог</span>
            </button>
            <button @click=${() => window.location.href = "/personal/cart"}>
                ${cartButton}
                <span>Корзина</span>
            </button>
            <button @click=${() => window.location.href = "/personal/orders/"}>
                ${ordersButton}
                <span>Заказы</span>
            </button>
            <button @click=${() => window.location.href = "/personal/"}>
                ${profileButton}
                <span>Профиль</span>
            </button>
        `
    }

    toogleMobileMenu() {
        if (this.menu) {
            this.menu.classList.toggle("visible")
            this.requestUpdate()
            this.switchAction = callback => {
                this.menu.classList.toggle("visible")
                this.menu.addEventListener("transitionend", () => {
                    callback()
                })
            }
        }
    }

    static get styles() {
        return css`
            :host {
                display: flex;
                align-items: center;
                justify-content: space-around;
                padding: 10px;
                position: fixed;
                bottom: 0dvh;
                width: 100vw;
                background: white;
                left: 0;
                z-index: 1000;
            }

            :host > button {
                display: flex;
                flex-direction: column;
                justify-content: center;
                appearance: none;
                border: none;
                background: none;
                align-items: center;
                gap: 2px;
                font-size: 10px;
                font-family: "Roboto Medium";
            }
        `
    }
}

window.customElements.define("main-toolbar", MainToolbar)


const personIconTT = svg`
<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M16.6732 16.5558C18.462 16.5558 20.1777 15.8452 21.4426 14.5803C22.7075 13.3153 23.4181 11.5997 23.4181 9.81087C23.4181 8.022 22.7075 6.30639 21.4426 5.04147C20.1777 3.77654 18.462 3.06592 16.6732 3.06592C14.8843 3.06592 13.1687 3.77654 11.9038 5.04147C10.6388 6.30639 9.92822 8.022 9.92822 9.81087C9.92822 11.5997 10.6388 13.3153 11.9038 14.5803C13.1687 15.8452 14.8843 16.5558 16.6732 16.5558Z" fill="#FF6E04"></path>
    <path d="M16.6732 19.9282C9.91477 19.9282 4.41089 24.4608 4.41089 30.0456C4.41089 30.4234 4.70767 30.7201 5.08538 30.7201H28.261C28.6388 30.7201 28.9355 30.4234 28.9355 30.0456C28.9355 24.4608 23.4316 19.9282 16.6732 19.9282Z" fill="#FF6E04"></path>
</svg>
`

const compareIconTT = svg`
<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M26.6013 28.7682H3.93831C3.4221 28.7682 2.99402 28.3503 2.99402 27.8464C2.99402 27.3424 3.4221 26.9246 3.93831 26.9246H26.6013C27.1176 26.9246 27.5456 27.3424 27.5456 27.8464C27.5456 28.3503 27.1176 28.7682 26.6013 28.7682Z" fill="#FF6E04"></path>
    <path d="M7.2119 11.1052H5.19741C4.50493 11.1052 3.93835 11.6583 3.93835 12.3343V22.9289C3.93835 23.6049 4.50493 24.158 5.19741 24.158H7.2119C7.90439 24.158 8.47096 23.6049 8.47096 22.9289V12.3343C8.47096 11.646 7.90439 11.1052 7.2119 11.1052ZM16.2771 3.26489H14.2626C13.5701 3.26489 13.0036 3.81798 13.0036 4.49397L13.0036 22.9314C13.0036 23.6074 13.5701 24.1605 14.2626 24.1605H16.2771C16.9696 24.1605 17.5362 23.6074 17.5362 22.9314L17.5362 4.49397C17.5362 3.81798 16.9696 3.26489 16.2771 3.26489ZM25.3423 7.05511H23.3278C22.6354 7.05511 22.0688 7.60819 22.0688 8.28419L22.0688 22.9302C22.0688 23.6062 22.6354 24.1593 23.3278 24.1593H25.3423C26.0348 24.1593 26.6014 23.6062 26.6014 22.9302L26.6014 8.28419C26.6014 7.60819 26.0348 7.05511 25.3423 7.05511Z" fill="#FF6E04"></path>
</svg>
`

const favouriteIconTT = svg`
<svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26.8645 18.1165V18.1039C25.7565 16.933 24.2078 16.2153 22.4829 16.2153C19.1464 16.2153 16.4395 18.9223 16.4395 22.2588C16.4395 23.8074 17.0312 25.2176 17.9881 26.2878C19.0961 27.5217 20.6951 28.3023 22.4829 28.3023C25.8194 28.3023 28.5264 25.5953 28.5264 22.2588C28.5264 20.6598 27.8969 19.1993 26.8645 18.1165ZM24.7366 23.2786H23.4272V24.651C23.4272 25.1672 22.9991 25.5953 22.4829 25.5953C21.9667 25.5953 21.5386 25.1672 21.5386 24.651V23.2786H20.2292C19.7004 23.2786 19.2849 22.8632 19.2849 22.3344C19.2849 21.8181 19.6878 21.4026 20.2166 21.3901H21.5386V20.131C21.5386 20.1058 21.5386 20.0806 21.5512 20.0555C21.5764 19.577 21.9919 19.1867 22.4829 19.1867C22.9866 19.1867 23.402 19.5896 23.4272 20.0932V21.3901H24.7366C25.2654 21.3901 25.6809 21.8181 25.6809 22.3344C25.6809 22.8632 25.2654 23.2786 24.7366 23.2786Z" fill="#FF6E04"></path>
    <path opacity="0.4" d="M28.5264 11.5491C28.5264 13.0474 28.2871 14.4324 27.8717 15.7166C27.6073 16.5602 27.2673 17.366 26.8644 18.1088C25.7564 16.9379 24.2078 16.2202 22.4829 16.2202C19.1464 16.2202 16.4394 18.9272 16.4394 22.2637C16.4394 23.8123 17.0312 25.2225 17.9881 26.2927C17.5222 26.5067 17.0941 26.683 16.7164 26.8089C16.2883 26.96 15.5833 26.96 15.1552 26.8089C12.1208 25.7765 5.98924 22.0119 3.99992 15.7166C3.58444 14.4324 3.34521 13.0474 3.34521 11.5491C3.34521 7.65863 6.48027 4.51099 10.3456 4.51099C12.6245 4.51099 14.6641 5.61896 15.9358 7.31868C16.5853 6.44844 17.4287 5.74158 18.3991 5.2542C19.3695 4.76682 20.4401 4.51235 21.526 4.51099C25.3913 4.51099 28.5264 7.65863 28.5264 11.5491Z" fill="#FF6E04"></path>
</svg>
`

const chatIconTT = svg`
<svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6621 23.0145L15.1131 21.2513H21.4343C24.5095 21.2513 27.0023 18.7585 27.0023 15.6833V5.56813C27.0023 4.98821 26.9137 4.42901 26.7492 3.90332C28.5223 4.55568 29.7871 6.25979 29.7871 8.25931V18.3745C29.7871 20.9371 27.7097 23.0145 25.1471 23.0145H24.3484L25.2399 29.0001L16.9195 23.0145H12.6621Z" fill="#FFC59B"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.64C0 2.0774 2.0774 0 4.64 0H20.6016C23.1642 0 25.2416 2.0774 25.2416 4.64V14.7552C25.2416 17.3178 23.1642 19.3952 20.6016 19.3952H13.9812L5.6608 25.3808L6.55228 19.3952H4.64C2.0774 19.3952 0 17.3178 0 14.7552V4.64ZM7.7024 10.0224C7.7024 11.3037 6.66366 12.3424 5.3824 12.3424C4.10115 12.3424 3.0624 11.3037 3.0624 10.0224C3.0624 8.7411 4.10115 7.7024 5.3824 7.7024C6.66366 7.7024 7.7024 8.7411 7.7024 10.0224ZM14.9408 10.0224C14.9408 11.3037 13.9021 12.3424 12.6208 12.3424C11.3396 12.3424 10.3008 11.3037 10.3008 10.0224C10.3008 8.7411 11.3396 7.7024 12.6208 7.7024C13.9021 7.7024 14.9408 8.7411 14.9408 10.0224ZM22.1792 10.0224C22.1792 11.3037 21.1405 12.3424 19.8592 12.3424C18.578 12.3424 17.5392 11.3037 17.5392 10.0224C17.5392 8.7411 18.578 7.7024 19.8592 7.7024C21.1405 7.7024 22.1792 8.7411 22.1792 10.0224Z" fill="#FF6E04"/>
</svg>
`


export class TopToolbar extends LitElement {
    render() {
        return html`
            <button @click=${() => {window.location.href = "/personal/"}}>${personIconTT}</button>
            <button @click=${() => {window.location.href = "/catalog/compare/"}}>${compareIconTT}</button>
            <button @click=${() => {window.location.href = "/wishlist/"}}>${favouriteIconTT}</button>
            <button @click=${() => {window.location.href = "/chat/"}}>${chatIconTT}</button>
        `
    }

    static get styles() {
        return css`
            :host {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            button {
                appearance: none;
                border: none;
                background: none;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                transition: 0.2s;
            }

            button:hover {
                transform: scale(1.2);
            }
        `
    }
}

window.customElements.define("top-toolbar", TopToolbar)